if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.desktopMql = window.matchMedia('(min-width: 1024px)');
        this.clicked = false;
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });
        }
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        this.initMediaHoverScroll();
        if (this.elements.thumbnails) this.handleScrollingState();
      }

      initMediaHoverScroll() {
        this.mediaWrapper = this.closest('.product__media-wrapper');
        if (!this.mediaWrapper || !this.desktopMql.matches) return;

        this.mediaWrapper.addEventListener('touchstart', () => {
          this.mediaWrapper.classList.add('is-media-scroll-active');
        }, { passive: true });

        this.mediaWrapper.addEventListener('touchend', () => {
          window.setTimeout(() => {
            this.mediaWrapper.classList.remove('is-media-scroll-active');
          }, 300);
        }, { passive: true });

        const thumbnailList = this.elements.thumbnails?.querySelector('.thumbnail-list');
        if (!thumbnailList) return;

        thumbnailList.addEventListener(
          'wheel',
          (event) => {
            const { scrollTop, scrollHeight, clientHeight } = thumbnailList;
            const maxScrollTop = scrollHeight - clientHeight;

            if (maxScrollTop <= 0) return;

            const scrollingDown = event.deltaY > 0;
            const scrollingUp = event.deltaY < 0;
            const atTop = scrollTop <= 0;
            const atBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;

            if ((scrollingDown && !atBottom) || (scrollingUp && !atTop)) {
              event.stopPropagation();
            }
          },
          { passive: true }
        );
      }

      getMediaScrollContainer() {
        if (!this.desktopMql.matches) return null;
        return this.elements.viewer;
      }

      onSlideChanged(event) {
        if(event?.currentElement) {
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
          );
          this.setActiveThumbnail(thumbnail);
        }
      }

      // scrollPage: false keeps the window where it is (variant changes), the gallery itself still moves to the media
      setActiveMedia(mediaId, prepend, scrollPage = true) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        this.clicked = true;

        window.setTimeout(() => {
          const scrollContainer = this.getMediaScrollContainer();

          if (scrollContainer) {
            scrollContainer.scrollTo({ top: activeMedia.offsetTop, behavior: 'smooth' });
          } else {
            if (!this.mql.matches || this.elements.thumbnails) {
              activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
            }
            if (scrollPage !== false) {
              const activeMediaRect = activeMedia.getBoundingClientRect();
              const headerHeight = document.querySelector('header.header')?.offsetHeight || 0;
              const top = activeMediaRect.top + window.scrollY - headerHeight;
              window.scrollTo({ top: top, behavior: 'smooth' });
            }
          }

          setTimeout(() => {
            this.clicked = false;
          }, 500);
        });

        // this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      handleScrollingState() {
        const thumbnails = $('.thumbnail-list .thumbnail-list__item');
        const galleryImages = this.querySelectorAll('.product__media-item');
        const scrollContainer = this.getMediaScrollContainer();

        const toggleThumbnailState = (id) => {
          thumbnails.find("button[aria-current='true']").removeAttr('aria-current');

          const matchingThumbnail = thumbnails.filter(`[data-target="${id}"]`);

          matchingThumbnail.find('button').attr('aria-current', 'true');
        };

        const observerOptions = {
          root: scrollContainer,
          rootMargin: '0px',
          threshold: 0.5,
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const mediaId = entry.target.dataset.mediaId;
              if (this.clicked === false) {
                toggleThumbnailState(mediaId);
              }
            }
          });
        }, observerOptions);

        galleryImages.forEach((image) => {
          observer.observe(image);
        });
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        if (this.desktopMql.matches) {
          const thumbnailList = this.elements.thumbnails.querySelector('.thumbnail-list');
          if (!thumbnailList) return;

          const listRect = thumbnailList.getBoundingClientRect();
          const thumbRect = thumbnail.getBoundingClientRect();

          if (thumbRect.top >= listRect.top && thumbRect.bottom <= listRect.bottom) return;

          const targetTop = thumbnail.offsetTop - thumbnailList.offsetTop;
          const maxScrollTop = thumbnailList.scrollHeight - thumbnailList.clientHeight;
          thumbnailList.scrollTo({
            top: Math.min(targetTop, maxScrollTop),
            behavior: 'smooth',
          });
          return;
        }

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
